import React from 'react';
import { Box } from '@mantine/core';
import { DataTable } from 'mantine-datatable';
import { getSurveyItemsColumns } from '../../pages/price-surveys/columns';
import { SurveyItemRow } from '../../pages/price-surveys/types';
import { surveyDetailsTableStyles } from '../../constants/tableStyles';

export type SurveyDataTableProps = {
    tableData: SurveyItemRow[];
    surveyItemsColumns: ReturnType<typeof getSurveyItemsColumns>;
    isLoading: boolean;
    showDivisionalManagerProposedSelling: boolean;
    onOpenPriceChangeRequest?: (requestId: string) => void;
};

export function SurveyDataTable({
    tableData,
    surveyItemsColumns,
    isLoading,
    showDivisionalManagerProposedSelling,
    onOpenPriceChangeRequest,
}: SurveyDataTableProps) {
    const tableKey = showDivisionalManagerProposedSelling
        ? 'divisional-manager'
        : 'sm';

    const pcrRowClickMode = Boolean(onOpenPriceChangeRequest);

    return (
        <Box className="h-full min-h-0 overflow-auto rounded-md border border-[var(--mantine-color-gray-3)]">
            <DataTable
                key={tableKey}
                withTableBorder={false}
                verticalSpacing="sm"
                fz="sm"
                noRecordsText="No survey items available"
                withColumnBorders={false}
                highlightOnHover={!pcrRowClickMode}
                records={tableData}
                columns={surveyItemsColumns}
                fetching={isLoading}
                idAccessor="id"
                classNames={{
                    table: 'selection-column-fix',
                }}
                styles={surveyDetailsTableStyles}
                onRowClick={
                    pcrRowClickMode && onOpenPriceChangeRequest
                        ? ({ record }) => {
                              const requestId = record.priceChangeRequest?.id;
                              if (requestId) {
                                  onOpenPriceChangeRequest(requestId);
                              }
                          }
                        : undefined
                }
                rowClassName={
                    pcrRowClickMode
                        ? record =>
                              record.priceChangeRequest?.id
                                  ? 'survey-pcr-row--clickable cursor-pointer'
                                  : 'survey-pcr-row--static !cursor-default'
                        : undefined
                }
            />
        </Box>
    );
}
